/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Divider, Grid, makeStyles } from '@material-ui/core';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch } from 'react-redux';
import PopupText from '../common/PopupText';
import PopupContentText from '../common/PopupContentText';
import Theme from '../ui/Theme';
import EditIcon from '../../assets/EditIcon';
import DeleteBadge from '../../assets/DeleteBadge';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import Image from '../common/Image';

const customStyles = {
  content: {
    height: '511px',
    width: '590px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};
const useStyles = makeStyles(() => ({
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
  },
  badgeId: {
    fontSize: '12px',
    fontWeight: '500',
    marginTop: '-7px',
  },
  popupMainContainer: {
    marginTop: '43px',
  },
}));

const BadgeDetailsPopup = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [badgeName, setBadgeName] = useState('');
  const [unlockDescription, setUnlockDescription] = useState('');
  const [lockDescription, setLockDescription] = useState('');
  const [type, setType] = useState('');
  const [unlockedThumbnail, setUnlockedThumbnail] = useState('');
  const [breakpoint, setBreakpoint] = useState(1);
  const [badgeId, setBadgeId] = useState(null);

  const getBadgeDetails = async () => {
    await service
      .get(apiEndpoints.BADGES_UPDATE_BADGE.replace('BADGE_ID', props.id))
      .then((res) => {
        if (res !== undefined) {
          setBadgeName(res.name);
          setBadgeId(res.id);
          setUnlockDescription(res.unlockedDescription);
          setLockDescription(res.lockedDescription);
          if (res.type !== 'dose') setType(res.type.charAt(0).toUpperCase() + res.type.slice(1));
          else setType('Story');
          setUnlockedThumbnail(res.unlockedImageUrl);
          setBreakpoint(res.breakpoint);
          dispatch(showProgress(false));
        }
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };
  useEffect(() => {
    dispatch(showProgress(true));
    getBadgeDetails();
  }, []);
  return (
    <Modal isOpen onRequestClose={props.close} style={customStyles}>
      <Grid container direction="row">
        <Grid item xs={9}>
          <Grid container direction="column">
            <Grid item className={classes.popupHeading}>
              Badge Details
            </Grid>
            <Grid item className={classes.badgeId}>
              Badge Id: {badgeId}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1}>
          <DeleteBadge className={classes.popupCloseBtn} click={props.delete} close={props.close} />
        </Grid>
        <Grid item xs={1}>
          <EditIcon className={classes.popupCloseBtn} click={props.edit} close={props.close} />
        </Grid>
        <Grid item xs={1}>
          <CloseIcon className={classes.popupCloseBtn} onClick={props.close} />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item style={{ width: '100%', height: '265px' }}>
          <Grid container direction="row" style={{ width: '100%', height: '100%' }}>
            <Grid item style={{ width: '50%' }}>
              <Image
                alt=""
                src={unlockedThumbnail}
                style={{
                  width: '145px',
                  height: '171px',
                  display: 'block',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  marginTop: '30px',
                }}
              />
            </Grid>
            <Grid item style={{ width: '50%', height: '100%' }}>
              <Grid
                container
                direction="column"
                justifyContent="space-around"
                alignItems="start"
                style={{ height: '100%' }}
              >
                <Grid item>
                  <PopupText text="BADGE NAME" />
                  <PopupContentText text={badgeName} style={{ marginTop: '8px' }} />
                </Grid>
                <Grid item>
                  <PopupText text="Badge Type" />
                  <PopupContentText text={type} style={{ marginTop: '8px' }} />
                </Grid>
                <Grid item>
                  <PopupText text="Unlock Count" />
                  <PopupContentText text={breakpoint} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ width: '100%' }}>
          <Divider variant="middle" style={{ marginTop: '30px', marginBottom: '30px' }} />
        </Grid>
        <Grid item style={{ width: '100%' }}>
          <Grid
            container
            direction="row"
            style={{ width: '100%' }}
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Grid item style={{ width: '50%' }}>
              <PopupText text="BADGE LOCK DESCRIPTION" />
              <PopupContentText text={lockDescription}></PopupContentText>
            </Grid>
            <Grid item style={{ width: '50%' }}>
              <PopupText text="BADGE UNLOCK DESCRIPTION" />
              <PopupContentText text={unlockDescription}></PopupContentText>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default BadgeDetailsPopup;
